// extracted by mini-css-extract-plugin
export var childrenContainer = "_4d-0";
export var virtualScrollArea = "_4d-1";